import React, { useContext } from 'react';
import { CaptionText } from '@paypalcorp/pp-react-text';
import MessageIframe from '@MerchantConfigurator/components/messaging/Preview/MessageIframe';
import { DynamicLayoutBlocks } from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context';
import PropTypes from 'prop-types';

const DynamicLayout = ({ layout, messageConfig, offerType, productPrice, darkMode }) => {
  const renderDynamicBlock = ({ layout, messageConfig, offerType, productPrice }) => {
    const { className = '', style = {}, type = '' } = layout;
    const { content } = useContext(ApplicationContext);

    switch (type) {
      case DynamicLayoutBlocks.CONTAINER:
        return layout?.blocks?.map((block, index) => {
          return (
            <DynamicLayout
              key={index}
              layout={block}
              messageConfig={messageConfig}
              productPrice={productPrice}
              darkMode={darkMode}
            />
          );
        });

      case DynamicLayoutBlocks.TEXT:
        return (
          <CaptionText style={{ ...style }}>
            {content[layout?.message] || layout?.message}
          </CaptionText>
        );

      case DynamicLayoutBlocks.IMAGE:
        return <img className={className} style={{ ...style }} src={layout?.src} />;

      case DynamicLayoutBlocks.UPSTREAMMESSAGE:
        return (
          <div className={className} style={{ ...style }}>
            <MessageIframe
              messageConfig={messageConfig}
              offerType={offerType}
              productPrice={productPrice}
              darkMode={darkMode}
            />
          </div>
        );

      case DynamicLayoutBlocks.NODE:
        return layout?.node;

      default:
        return null;
    }
  };

  return (
    <div className={layout?.className} style={{ ...layout?.style }}>
      {renderDynamicBlock({
        layout,
        messageConfig,
        offerType,
        productPrice
      })}
    </div>
  );
};

export default DynamicLayout;

DynamicLayout.propTypes = {
  layout: PropTypes.object,
  messageConfig: PropTypes.object,
  offerType: PropTypes.string,
  productPrice: PropTypes.string
};
